import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Comprehensive ResizeObserver error suppression
// These are harmless browser warnings from Radix UI components
const suppressResizeObserver = () => {
  // Override the global ResizeObserver to catch and suppress loop errors
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            if (!e.message.includes('ResizeObserver')) {
              throw e;
            }
          }
        });
      });
    }
  };

  // Suppress console errors
  const originalError = console.error;
  console.error = function(...args) {
    if (
      args[0] && 
      typeof args[0] === 'string' && 
      (args[0].includes('ResizeObserver') || args[0].includes('loop completed'))
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress uncaught errors
  window.addEventListener('error', (event) => {
    if (
      event.message && 
      (event.message.includes('ResizeObserver') || event.message.includes('loop completed'))
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  // Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason && 
      event.reason.message && 
      (event.reason.message.includes('ResizeObserver') || event.reason.message.includes('loop completed'))
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });
};

suppressResizeObserver();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
